import { render } from "./ArticlesView.vue?vue&type=template&id=a9c09526"
import script from "./ArticlesView.vue?vue&type=script&lang=js"
export * from "./ArticlesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__